module.exports = __webpack_public_path__ + "static/glaive-b71bc0f9f2e83dd2fda051e6e01ffc6d.jpg";